import { render, staticRenderFns } from "./group-item.vue?vue&type=template&id=d880931c&scoped=true"
import script from "./group-item.vue?vue&type=script&lang=js"
export * from "./group-item.vue?vue&type=script&lang=js"
import style0 from "./group-item.vue?vue&type=style&index=0&id=d880931c&prod&lang=scss"
import style1 from "./group-item.vue?vue&type=style&index=1&id=d880931c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d880931c",
  null
  
)

export default component.exports